import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    svg {\n        transform: rotate(0.5turn);\n    }\n    margin-right: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    border: 0 none;\n    appearance: none;\n    background-color: transparent;\n    color: ", ";\n\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: initial;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    cursor: pointer;\n    user-select: none;\n    color: ", ";\n    ", ";\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: ", " ", " 0 ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { getPropsBlocker } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { color, reset, spacing } from '../../../system';
import { transition } from '../../../system/mixins/transition';
var propertyList = {
  open: true,
  onDirtyInternalValueUTCUpdate: true,
  dirtyInternalValueUTC: true
};
export var DatePickerTopBarRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject(), spacing(4), spacing(5), spacing(6), getComponentOverride('DatePickerTopBar'));

var getMonthYearSelectorToggleStyle = function getMonthYearSelectorToggleStyle(_ref) {
  var open = _ref.open;
  var result = {};

  if (open) {
    result = css(_templateObject2(), result, color('neutral.04'));
  }

  return result;
};

export var DatePickerTopBarMonthYearSelectorToggle = styled.a.withConfig(getPropsBlocker(propertyList))(_templateObject3(), reset(), color('neutral.06'), transition({
  color: 0.1
}), getMonthYearSelectorToggleStyle);
export var DatePickerTopBarMonthNavigation = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), reset(), color('neutral.06'));

var getMonthNavigationButtonForwardStyle = function getMonthNavigationButtonForwardStyle(_ref2) {
  var disabled = _ref2.disabled;
  var result = {};

  if (disabled) {
    result = css(_templateObject5(), result, color('neutral.04'));
  }

  return result;
};

export var DatePickerTopBarMonthNavigationButtonForward = styled.button.withConfig(getPropsBlocker(propertyList))(_templateObject6(), color('neutral.06'), getMonthNavigationButtonForwardStyle);
export var DatePickerTopBarMonthNavigationButtonBackward = styled(DatePickerTopBarMonthNavigationButtonForward)(_templateObject7(), spacing(5));